import React from 'react';
import './Blog.css';

import { extractDateParts } from '../../utils'; // Utility function to extract date parts

import { FaFolderOpen, FaUserCircle } from 'react-icons/fa'; // Importing icons
import { Link } from 'react-router-dom'; // Importing Link for navigation


const Blog = ({ blog }) => {

  const { id, image, date, heading, admin, category } = blog; // Extracting data from blog
  const { day, shortMonth, year } = extractDateParts(date); // Extracting formatted date parts using utility function

  return (
    <div className='blog-item' key={id}>

      {/* Blog image */}
      <div className='image'>
        <img src={image} alt={heading} />
      </div>

      <div className='content'>

        <div className="date">{day} {shortMonth}, {year}</div>

        {/* Blog title with dynamic navigation */}
        <Link
          to={{
            pathname: '/Blogs/' + heading,
          }}
          state={blog}
          className='main-heading'>
          {heading}
        </Link>

        {/* Blog details section */}
        <div className='details'>

          {/* Admin information with icon */}
          <h3>
            <div className='icon'><FaUserCircle /></div>
            <span>By {admin}</span>
          </h3>

          {/* Blog category with navigation link */}
          <h3>
            <div className='icon'><FaFolderOpen /></div>
            <Link className='category label' to={`/Blogs/category/${category}`}>
              {category}
            </Link>
          </h3>

        </div>

      </div>

    </div>
  );
};

export default Blog;